import AcademicProfileService from "../../apiServices/student/academicProfileService";
import { setAcademicDetails } from "../../store/slices/student/acradamicProfileSlice";
import { alertConstants } from "../../helper/sweet-alert";

export function getAcademicDetails(id: string) {
  return async function (dispatch: any, getState: any) {
    let response = await AcademicProfileService.getAcademicDetails(id);
    if (response?.success === true) {
      dispatch(setAcademicDetails(response.data));
    } else {
      console.log("error");
    }
  };
}

export function updateAcademicDetails(
  data: any,
  id: number,
  callback: Function
) {
  return async function (dispatch: any, getState: any) {
    let response = await AcademicProfileService.updateAcademicDetails(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}
